import React from 'react'
import Membership from '../../Components/Membership';
import MembershipForm from '../../Components/MemberShipForm';
import ApplicationReview from '../../Components/ApplicationReview';
import Checkout from '../../Components/Checkout';
import PaymentSuccess from '../../Components/PaymentSuccess';
import { useParams } from 'react-router-dom';

export default function RegisterPage() {
    const {step} = useParams();
    const renderStepComp = () => {
        switch (step) {
            case "select-membership":
                return <Membership />;
            case "membership-form":
                return <MembershipForm />;
            case "application-review":
                return <ApplicationReview />;
            case "checkout":
                return <Checkout />;
            case "payment-success":
                return <PaymentSuccess />;
            default:
                return <Membership />;
        }
    };

    return <>{renderStepComp()}</>;
}
